export const REFUND_STATUS_NONE = 0
export const REFUND_STATUS_PENDING = 1
export const REFUND_STATUS_REFUNDED = 2
export const REFUND_STATUS_REJECTED = 3

export const REFUND_STATUS_LABEL = {
  [REFUND_STATUS_NONE]: '',
  [REFUND_STATUS_PENDING]: '退款审核中',
  [REFUND_STATUS_REFUNDED]: '已退款',
  [REFUND_STATUS_REJECTED]: '退款已驳回'
}

export function canApplyRefund(order) {
  if (!order) return false
  const paid = Number(order.paid_amount) > 0
  const status = Number(order.status)
  const refundStatus = Number(order.refund_status || REFUND_STATUS_NONE)
  return paid
    && status !== 4
    && status !== 5
    && refundStatus !== REFUND_STATUS_PENDING
    && refundStatus !== REFUND_STATUS_REFUNDED
}
